import { curry } from "lodash";

import { topNItemMap } from "app/pages/sales-intelligence/sub-modules/company-search/configuration/tableActions";
import type { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";
import type SelectionDropdown from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown/SelectionDropdown";
import type { SelectionDropdownItem } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown-item/types";
import { getItemWithTheSmallestValueOrManual } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/utils/selection-dropdown";

import AllResultsSelectionItem from "../../../table-actions-panel/models/selection-dropdown-item/AllResultsSelectionItem/AllResultsSelectionItem";

type ValuesParams = {
    topNValues: readonly number[];
};

const createAssignToUserSelectionDropdown = ({ topNValues }: ValuesParams, leadsType: LeadsType): SelectionDropdown => {
    return {
        getInitiallySelectedItem: getItemWithTheSmallestValueOrManual,
        getItems(numberOfResults: number): SelectionDropdownItem[] {
            const TopNSelectionItem = topNItemMap[leadsType];

            const topNItems: SelectionDropdownItem[] = topNValues
                .filter((value) => value <= numberOfResults)
                .map((value) => new TopNSelectionItem({ id: `top-${value}`, value }));

            if (numberOfResults < topNValues[topNValues.length - 1]) {
                return topNItems.concat(new AllResultsSelectionItem(numberOfResults) as SelectionDropdownItem);
            }

            return topNItems;
        },
    };
};

export default curry(createAssignToUserSelectionDropdown);
